import Slider from 'rc-slider';

import 'rc-slider/assets/index.css';
import './Slider.module.scss';

export default Slider;
